module.exports = __webpack_public_path__ + "img/up.e26ed630.svg";